import TextInputPage from '@app-studio-web/ui/pages/TextInputPage'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'vape_spending'

export default function VapeSpendingPage() {
  const submit = useSubmit()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value') || ''
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const formData = new FormData(event.currentTarget)
    const value = formData.get('value') as string

    if (!value.trim()) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How much do you spend on vapes approximately each month?',
      answer_key: value.toLowerCase(),
      answer: value,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <TextInputPage
      heading="pages.onboarding.vapeSpending.heading"
      placeholder="pages.onboarding.vapeSpending.placeholder"
      pattern="^\d+(\.\d{1,2})?$"
      onSubmit={handleSubmit}
      value={value}
    />
  )
}
